import Vue from 'vue'
import Router from 'vue-router'

import menuModule from 'vuex-store/modules/menu'
import lazyLoading from '../store/modules/menu/lazyLoading'
import axios from 'axios'


axios.defaults.baseURL = process.env.API_SERVER_ENDPOINT
// axios.defaults.headers.common['Authorization'] = null;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

Vue.use(Router)

export default new Router({
  routes: [
    ...generateRoutesFromMenu(menuModule.state.items),
    { path: '/op/:id/:type', component: lazyLoading('custom/Operations') },
    { path: '/invoice/:shopid/:id', component: lazyLoading('invoice/Invoice') },
    { path: '/invoice/:shopid/:id/:bank', component: lazyLoading('invoice/Invoice') },
    { path: '/invoice/:shopid/:id/:code/:phone', component: lazyLoading('invoice/Invoice') },
    { path: '*', redirect: { name: getDefaultRoute(menuModule.state.items).name } }
  ]
})

function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}

function getDefaultRoute (menu = []) {
  let defaultRoute

  menu.forEach((item) => {
    if (item.meta.default) {
      defaultRoute = item
    } else if (item.children) {
      let defaultChild = item.children.find((i) => i.meta.default)
      defaultRoute = defaultChild || defaultRoute
    }
  })
  console.log('defaultRoute', defaultRoute)
  return defaultRoute
}



// WEBPACK FOOTER //
// ./src/router/index.js